import { IsNumber, IsString } from 'class-validator';

export class TreasuryBankingAccountDto {
  @IsNumber()
  ican?: number;

  @IsString()
  name?: string;

  @IsString()
  currencyCode?: string;

  @IsString()
  bic?: string;

  @IsString()
  iban?: string;

  @IsString()
  accountNumber?: string;
  
  @IsString()
  sortCode?: string;

  @IsNumber()
  balance?: number;
}
